import { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useLocation } from "react-router-dom";
import SchoolInnerPageBanner from "../../components/SchoolInnerPageBanner";
import AdmissionApplicationForm from "../../components/AdmissionApplicationForm";
const baseAPIUrl = process.env.REACT_APP_API_BASE_URL;

const AdmissionsPage = () => {
  const location = useLocation();
  const { school_slug } = useParams();

  const [loading, setLoading] = useState(true);
  const [criteria, setCriteria] = useState(null);
  const [rows, setRows] = useState([]);


  const [procedure, setProcedure] = useState(null);
  const [lists, setLists] = useState([]);
  const [image, setImage] = useState("");

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const sectionId = location.state?.scrollTo;
    if (!sectionId) return;

    const timer = setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 150);

    return () => clearTimeout(timer);
  }, [location.key]);

  useEffect(() => {
    scrollToTop();
  }, []);

  //  
  useEffect(() => {
    const finalSchoolSlug = school_slug || "tigps-main";

    fetchCriteria();
    fetchProcedure();
  }, [school_slug]);


  /* ---------------- FETCH CRITERIA DATA ---------------- */
  const fetchCriteria = async () => {
    const finalSchoolSlug = school_slug || "tigps-main";
    try {
      const res = await axios.get(
        `${baseAPIUrl}admin/admission_page/get_criteria_section/${finalSchoolSlug}`,
        { withCredentials: true }
      );

      console.log("API RESPONSE:", res.data);

      if (res.data.status === 1) {
        setCriteria(res.data.data.criteria_section);
        setRows(res.data.data.criteria_table);

      }
    } catch (error) {
      console.error("Criteria API error:", error);
    }
  };


  /* ---------------- FETCH APPLICATION PROCEDURE DATA ---------------- */
  const fetchProcedure = async () => {
    const finalSchoolSlug = school_slug || "tigps-main";
    try {
      const res = await axios.get(
        `${baseAPIUrl}admin/admission_page/get_admission_procedure_section/${finalSchoolSlug}`
      );

      console.log("PROCEDURE API FULL RESPONSE:", res.data);

      if (
        res.data.status === 1 &&
        res.data.data &&
        res.data.data.section
      ) {
        setProcedure(res.data.data.section);
        setLists(res.data.data.lists || []);
      } else {
        setProcedure(null);
        setLists([]);
      }
    } catch (err) {
      console.error("Procedure error:", err);
      setProcedure(null);
      setLists([]);
    }
  };



  const groupedLists = lists.reduce((acc, item) => {
    if (!acc[item.title]) {
      acc[item.title] = [];
    }
    acc[item.title].push(item.content);
    return acc;
  }, {});

  // For Criteria
  const hasCriteriaSection =
    criteria &&
    (
      criteria.heading ||
      criteria.description ||
      (Array.isArray(rows) && rows.length > 0) ||
      criteria.note_1 ||
      criteria.note_2
    );


  return (
    <div className="admissions-page">
      <SchoolInnerPageBanner/>

      {/* Criteria Section */}
      {hasCriteriaSection && (
        <section id="criteria" style={{ padding: "80px 20px", background: "white" }}>
          <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
            {criteria?.heading && (
              <h2 style={headingStyle}>{criteria.heading}</h2>
            )}

            {criteria?.description && (
              <p style={descStyle}>{criteria.description}</p>
            )}

            {Array.isArray(rows) && rows.length > 0 && (
              <div style={{ display: "flex", justifyContent: "center", marginBottom: "30px" }}>
                <table style={tableStyle}>
                  <thead>
                    <tr style={{ backgroundColor: '#f8f9fa' }}>
                      <th style={thStyle}>Class</th>
                      <th style={thStyle}>Age Group</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((row, index) => (
                      <tr key={index}>
                        <td style={tdStyle}>{row.class_name}</td>
                        <td style={tdStyle}>{row.age_group}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {criteria?.note_1 && (
              <p style={noteStyle}>{criteria?.note_1}</p>
            )}

            {criteria?.note_2 && (
              <p style={noteStyle}>{criteria?.note_2}</p>
            )}
          </div>
        </section>
      )}

      {/* Admission Application Procedure Section */}
      {procedure?.heading && (
        <section id="admission-application-procedurer" style={{ padding: "80px 20px", background: "#f8f9fa" }}>
          <div style={{ maxWidth: "1200px", margin: "0 auto" }}>

            <h2 style={headingStyle}>{procedure?.heading}</h2>

            <p className="tigps-main-admission-procedure-p">{procedure?.intro_paragraph}</p>

            <div className="mv-wrapper">
              <div className="mv-box-admission">
                <h4 style={boxTitle}>{procedure?.manual_title}</h4>
                <p className="tigps-main-admission-procedure-p">{procedure?.manual_content}</p>
              </div>

              <div className="mv-box-admission">
                <h4 style={boxTitle}>{procedure?.online_title}</h4>
                <p className="tigps-main-admission-procedure-p">{procedure?.online_content}</p>
              </div>
            </div>


            {/* MENU / LISTS */}
            {Object.keys(groupedLists).length > 0 && (
              Object.keys(groupedLists).map((title, index) => (
                <div key={index} style={whiteBoxs}>
                  <h4 style={boxTitle}>{title}</h4>

                  <ul style={{ paddingLeft: "20px", marginTop: "10px" }}>
                    {groupedLists[title].map((text, i) => (
                      <li
                        key={i}
                        style={{ marginBottom: "8px", lineHeight: "1.6", fontSize: '0.9rem' }}
                      >
                        {text}
                      </li>
                    ))}
                  </ul>
                </div>
              ))
            )}


            <div style={{ background: 'rgb(100, 19, 32)', color: 'white', padding: '20px', borderRadius: '10px', textAlign: 'center', marginBottom: '40px' }}>
              <h4 style={{ fontSize: '1.5rem',  marginBottom: '10px', fontFamily: 'Lora' }}>{procedure?.withdrawal_title}</h4>
              <p style={{ marginBottom: '0' }}>{procedure?.withdrawal_content}</p>
            </div>

            {procedure?.image && procedure.image.trim() !== "" && (
              <div style={{ textAlign: "center" }}>
                <img
                  src={`${baseAPIUrl}assets/images/admission/${procedure.image}?t=${Date.now()}`}
                  alt="Admission Open"
                  style={{
                    maxWidth: "600px",
                    width: "100%",
                    borderRadius: "10px",
                    boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
                  }}
                />
              </div>
            )}
          </div>
        </section>
      )}

      {/* Application Form Section */}
      <AdmissionApplicationForm/>
    </div>
  );
};


/* ===== STYLES ===== */

const headingStyle = {
  fontSize: "2.5rem",
  fontWeight: "600",
  color: "rgb(100, 19, 32)",
  textAlign: "center",
  marginBottom: "30px",
  fontFamily: "Lora",
};
const descStyle = {
  color: "#333",
  marginBottom: "30px",
  textAlign: "center",
};
const tableStyle = {
  backgroundColor: 'white',
  border: '2px solid rgb(100, 19, 32)',
  borderCollapse: "collapse",
  width: "100%",
  maxWidth: "600px",
  color: '#333',
  borderRadius: '10px',
  overflow: 'hidden',
};
const thStyle = {
  padding: "15px",
  border: "1px solid #ddd",
  color: "rgb(100, 19, 32)",
  textAlign: 'center',
  fontSize: '1.2rem',
  fontFamily: 'Lora',
};
const tdStyle = {
  padding: '12px 15px',
  border: "1px solid #ddd",
  textAlign: "center",
  fontSize: '1rem',
  fontFamily: 'Metropolis-Regular',
};
const noteStyle = {
  textAlign: "center",
  textAlign: 'center',
  marginBottom: '10px',
};
const whiteBox = {
  background: "#fff",
  padding: 25,
  borderRadius: 10,
  border: "2px solid rgb(100,19,32)",
  marginBottom: 25,
  flex: '1',
  display: 'flex',
  flexDirection: 'column',
  height: '200px'
};
const whiteBoxs = {
  background: "#fff",
  padding: 25,
  borderRadius: 10,
  border: "2px solid rgb(100, 19, 32)",
  marginBottom: 25,
};
const boxTitle = {
  color: "rgb(100, 19, 32)",
  fontSize: "1.5rem",
  marginBottom: 10,
};
const boxText = {
  fontSize: "0.9rem",
};

export default AdmissionsPage;